import React from 'react';
import LoginUi from '../../ui/auth/loginUi';

const LoginPage = () => {

  return (
    <div className="min-h-screen w-full flex bg-white">
      {/* Left Side: Visual/Branding (Hidden on mobile) */}
      <div className="hidden lg:flex lg:w-1/2 relative bg-thirdly items-center justify-center p-12">
        {/* <div className="absolute inset-0 z-0 opacity-40">
            <img src={loginPhoto} alt="Logistics" className="w-full h-full object-cover" />
        </div> */}
        <div className="relative z-10 max-w-md text-center">
            <h1 className="text-5xl font-bold text-white mb-6">Fyndura</h1>
            <p className="text-blue-100 text-lg">
                Manage your Ads, Orders, Users, and optimize your logistics operations in one powerful dashboard.
            </p>
        </div>
      </div>

      {/* Right Side: Login Form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-[#F4F5FA] sm:bg-white">
        <div className="w-full max-w-md">
          <div className="mb-10 text-center lg:text-left">
            <h2 className="text-3xl font-bold text-[#02182D] mb-2">Welcome Back</h2>
            <p className="text-gray-500">Please enter your admin credentials</p>
          </div>
          
          <div className="bg-white p-2 sm:p-0 rounded-xl">
             <LoginUi />
          </div>
          
          <p className="mt-8 text-center text-sm text-gray-400">
            &copy; {new Date().getFullYear()} Fyndura Company.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;